// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridPivot.jsx" company="Izenda">  Copyright
// (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridPivot component
 */
!(function() {
  var React = require('react');
  var ColumnDataObject = require('logic/models/Izenda.ColumnDataObject');
  var ProcessData = require('logic/Izenda.ReportPartGridProcessData');
  var connect = require('share/enhancers/Izenda.Connect');
  var reportPartUtils = require('share/utils/Izenda.ReportPartUtils');
  var { get } = require('lodash/fp');

  var SubTotalCell = connect()(function(props) {
    var localization = props.localization;
    var rowData = props.rowData;
    var columnData = props.columnData;
    var subTotalMapping = props.subTotalMapping;
    var rowExpanders = props.rowExpanders;
    var forDrillDown = props.forDrillDown;
    var fieldElement = props.fieldElement;
    var value = ProcessData.getDataForCell(columnData, rowData, rowExpanders, forDrillDown, subTotalMapping);

    var dataFormattings = get('element.properties.dataFormattings', columnData);
    var formattedValueData = reportPartUtils.getDataFormat(
      value.data,
      {
        alternativeText: get('properties.dataFormattings.alternativeText', fieldElement),
        fieldFormatData: get('format.format', dataFormattings),
        fieldDataType: get('previewDataType', fieldElement)
      }
    );

    if (!value.isEmpty || props.isDisplayCell) {
      var subTotal = dataFormattings.subTotal;
      return (
        <span className="sub-total" title={subTotal.label}>
          {forDrillDown && columnData.type === ColumnDataObject.COLUMN_TYPE.ROW
            ? String.format(localization.getText('REPORTDESIGNER_LABEL_TOTAL_FOR'), formattedValueData)
            : formattedValueData}
        </span>
      );
    }
    return null;
  });

  module.exports = SubTotalCell;
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.SubTotalCell.jsx